import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Colors from 'utils/colors';

const styles = () => ({
  root: {
    width: 200,
    opacity: '1 !important',
  },
  title: {
    color: Colors.blue,
    fontSize: 12,
    fontWeight: 600,
  },
  description: {
    fontSize: 12,
    color: '#979797',
  },
  icon: {
    widht: 30,
    height: 30,
  },
});

function Tooltip(props) {
  const { tooltipId, children, classes, description, position } = props;

  return (
    <div>
      <ReactTooltip
        id={tooltipId}
        place={position || 'bottom'}
        type="light"
        effect="solid"
        className={classes.root}
        border
      >
        <Grid item xs={12}>
          <Typography align="left" className={classes.description}>
            {description}
          </Typography>
        </Grid>
      </ReactTooltip>
      <div data-tip data-for={tooltipId}>
        {children}
      </div>
    </div>
  );
}

Tooltip.propTypes = {
  tooltipId: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.object,
  description: PropTypes.string,
  position: PropTypes.string,
};

export default withStyles(styles)(Tooltip);
